/* eslint-disable eqeqeq */
import {
  DirectionControlWrapper,
  IPointContainerProps,
  Marker,
  PointContainer
} from 'components/PointComp/PointComp.styles';
import React from 'react';

export interface IPointComp extends IPointContainerProps {
  handleClick: React.MouseEventHandler;
  handleMouseEnter?: React.MouseEventHandler;
  handleMouseLeave?: React.MouseEventHandler;
}

const PointComp = ({
  position,
  expandFrom,
  handleClick,
  isExpanded,
  children,
  handleMouseEnter,
  handleMouseLeave
}: React.PropsWithChildren<IPointComp>) => (
  <PointContainer
    onClick={handleClick}
    position={position}
    expandFrom={expandFrom || 'left'}
    isExpanded={isExpanded}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
  >
    <DirectionControlWrapper expandFrom={expandFrom || 'left'}>
      <Marker sonarDelay={Math.random()} expandFrom={expandFrom || 'left'} />
      {children}
    </DirectionControlWrapper>
  </PointContainer>
);

export default PointComp;
